import { useState } from 'react';
import { Send, Loader2, CheckCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function NewsletterForm({ variant = 'default' }) {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setIsLoading(true);
    try {
      const response = await axios.post(`${API}/newsletter/subscribe`, {
        email,
        first_name: firstName || null,
      });
      
      if (response.data.success) {
        setIsSuccess(true);
        toast.success(response.data.message);
        setEmail('');
        setFirstName('');
        setTimeout(() => setIsSuccess(false), 3000);
      }
    } catch (error) {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  if (variant === 'footer') {
    return (
      <form onSubmit={handleSubmit} className="space-y-3" data-testid="newsletter-form-footer">
        <Input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="bg-white/10 border-white/20 text-white placeholder:text-white/50 focus:border-white/40"
          data-testid="newsletter-email-footer"
        />
        <Button 
          type="submit" 
          disabled={isLoading || isSuccess}
          className="w-full bg-white text-primary hover:bg-white/90"
          data-testid="newsletter-submit-footer"
        >
          {isLoading ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : isSuccess ? (
            <>
              <CheckCircle className="h-4 w-4 mr-2" />
              Subscribed!
            </>
          ) : (
            <>
              <Send className="h-4 w-4 mr-2" />
              Subscribe
            </>
          )}
        </Button>
      </form>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-lg" data-testid="newsletter-form">
      <div className="flex flex-col sm:flex-row gap-3">
        <Input
          type="text"
          placeholder="First name (optional)"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          className="flex-1"
          data-testid="newsletter-firstname"
        />
        <Input
          type="email"
          placeholder="Your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="flex-1"
          data-testid="newsletter-email"
        />
        <Button 
          type="submit" 
          disabled={isLoading || isSuccess}
          className="rounded-full px-8 btn-shine"
          data-testid="newsletter-submit"
        >
          {isLoading ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : isSuccess ? (
            <>
              <CheckCircle className="h-4 w-4 mr-2" />
              Done!
            </>
          ) : (
            <>
              <Send className="h-4 w-4 mr-2" />
              Subscribe
            </>
          )}
        </Button>
      </div>
      <p className="text-sm text-muted-foreground mt-3">
        Join 100+ artisans receiving tips, event updates, and business insights.
      </p>
    </form>
  );
}
